// extracted by mini-css-extract-plugin
module.exports = {"h1":"HeaderLogo_h1__3ca77","studioLogo":"HeaderLogo_studioLogo__1LkUv","hubLogo":"HeaderLogo_hubLogo__1rX-2","label":"HeaderLogo_label__2wUZo"};